export const API_BASE_URL = process.env.REACT_APP_API_NODE_BASE_URL || 'http://localhost:5000/api';
export const BASE_URL = process.env.REACT_APP_NODE_BASE_URL || 'http://localhost:5000';

// Admin API Endpoints
export const ADMIN_ENDPOINTS = {
  STATS: '/stats',
  USERS: '/users',
  USER_DETAILS: (userId) => `/users/${userId}`,
  USER_UPDATE: (userId) => `/users/${userId}`,
  USER_DELETE: (userId) => `/users/${userId}`,
  USERS_EXPORT: '/users/export',
  ANALYTICS: '/analytics',
  API_USAGE_ANALYTICS: '/dashboard/api-usage-analytics',
  GRANT_TOKENS: (userId) => `/users/${userId}/grant-tokens`,
  REVOKE_TOKENS: (userId) => `/users/${userId}/revoke-tokens`,
  BULK_GRANT_TOKENS: '/users/bulk-grant-tokens',
  LOGS: '/logs',
  LOGS_EXPORT: '/logs/export'
};

// API Configuration
export const API_CONFIG = {
  TIMEOUT: 10000,
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100
};

// User Status Options
export const USER_STATUS = {
  ALL: 'all',
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  DELETED: 'deleted'
};

// Sort Options
export const SORT_OPTIONS = {
  CREATED_AT: 'createdAt',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  TOKENS: 'tokens'
};

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc'
};

// Export Formats
export const EXPORT_FORMATS = {
  CSV: 'csv',
  JSON: 'json'
};

// Timeframe Options
export const TIMEFRAME_OPTIONS = {
  ONE_DAY: '1d',
  SEVEN_DAYS: '7d',
  THIRTY_DAYS: '30d',
  NINETY_DAYS: '90d'
};

// Support Ticket Categories
export const TICKET_CATEGORIES = {
  TECHNICAL: 'Technical',
  BILLING: 'Billing',
  GENERAL: 'General',
  FEATURE_REQUEST: 'Feature Request',
  BUG_REPORT: 'Bug Report'
};

// Support Ticket Priorities
export const TICKET_PRIORITIES = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  URGENT: 'Urgent'
};

// Support Ticket Statuses
export const TICKET_STATUSES = {
  OPEN: 'Open',
  IN_PROGRESS: 'In Progress',
  RESOLVED: 'Resolved',
  CLOSED: 'Closed'
};

// Priority Colors
export const PRIORITY_COLORS = {
  [TICKET_PRIORITIES.LOW]: 'bg-gray-100 text-gray-800',
  [TICKET_PRIORITIES.MEDIUM]: 'bg-violet-100 text-gray-800',
  [TICKET_PRIORITIES.HIGH]: 'bg-orange-100 text-orange-800',
  [TICKET_PRIORITIES.URGENT]: 'bg-red-100 text-red-800'
};

// Status Colors
export const STATUS_COLORS = {
  [TICKET_STATUSES.OPEN]: 'bg-orange-100 text-orange-800',
  [TICKET_STATUSES.IN_PROGRESS]: 'bg-blue-100 text-yellow-800',
  [TICKET_STATUSES.RESOLVED]: 'bg-green-100 text-green-800',
  [TICKET_STATUSES.CLOSED]: 'bg-gray-100 text-gray-800'
};

// Storage Keys
export const STORAGE_KEYS = {
  PERSIST_ROOT: 'persist:root',
  TOKEN: 'token'
};

// Utility function to get token from Redux Persist storage
export const getTokenFromStorage = () => {
  try {
    const persistedState = localStorage.getItem(STORAGE_KEYS.PERSIST_ROOT);
    if (persistedState) {
      const parsedState = JSON.parse(persistedState);
      const authState = JSON.parse(parsedState.auth);
      return authState.token;
    }
  } catch (error) {
    console.error('Error parsing persisted state:', error);
  }
  return null;
};
